import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';
import { toast } from 'sonner';
import { Instagram } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email }, {
        headers: { 'Content-Type': 'application/json' }
      });
      toast.success(t('subscribed'));
      setEmail('');
    } catch (error) {
      toast.error('Failed to subscribe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#1A1A1A] text-white py-16" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/ub3f0czw_-COSMO%20BEAUTY%20LOGO.svg" 
              alt="Cosmo Beauty Logo" 
              className="h-14 mb-4 brightness-0 invert"
            />
            <p className="text-sm text-[#8A8A8A] leading-relaxed">
              {t('heroSubtitle')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] mb-4 text-white">{t('shop')}</h3>
            <ul className="space-y-2">
              <li><Link to="/shop?category=foundation" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('foundation')}</Link></li>
              <li><Link to="/shop?category=blush" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('blush')}</Link></li>
              <li><Link to="/shop?category=eyeshadow" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('eyeshadow')}</Link></li>
              <li><Link to="/shop?category=mascara" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('mascara')}</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] mb-4 text-white">{t('customerService')}</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('about')}</Link></li>
              <li><Link to="/contact" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('contact')}</Link></li>
              <li><a href="#" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('privacyPolicy')}</a></li>
              <li><a href="#" className="text-sm text-[#8A8A8A] hover:text-white transition-colors">{t('termsConditions')}</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] mb-4 text-white">{t('subscribeNewsletter')}</h3>
            <form onSubmit={handleSubscribe} className="space-y-3" data-testid="newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('enterEmail')}
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-white py-3 px-0 text-sm text-white placeholder:text-white/40 focus:outline-none transition-colors"
                data-testid="newsletter-email-input"
              />
              <button 
                type="submit" 
                disabled={loading}
                className="bg-white text-[#1A1A1A] px-8 py-3 text-xs uppercase tracking-[0.2em] hover:bg-[#C6A87C] hover:text-white transition-all duration-300 disabled:opacity-50"
                data-testid="newsletter-submit-btn"
              >
                {loading ? 'Loading...' : t('subscribe')}
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col items-center gap-4">
            {/* Copyright */}
            <p className="text-xs text-white/60">
              © 2025 Cosmo Beauty. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;